import React from 'react';
import './index.css';
import { config } from './config';

function App() {
  const handleEmailClick = () => {
    window.location.href = 'mailto:contacto@restaurarportugal.pt';
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>{config.title}</h1>
        <p>{config.mission}</p>
        <div className="card">
          <h2>{config.ourMission}</h2>
          <p>{config.description}</p>
          <button className="btn" onClick={handleEmailClick}>{config.buttonText}</button>
        </div>
      </header>
    </div>
  );
}

export default App;
